<template>
  <div>
    <div class="network-management-header__content">
      <h1 class="network-management-header__title">
        {{ $t('page-name.network-management') }}
      </h1>
    </div>
    <div class="content-wrapper">
      <network-management-header />
      <app-content class="network-management">
        <div class="d-flex justify-content-end pb-2">
          <b-button variant="primary" @click="goToNewNetwork">
            {{ $t('network-management.new-network') }}
          </b-button>
        </div>
        <network-management-table
          :items="items"
          :loading="loading"
          :currentPage="currentPage"
          :total-rows="totalItems"
          :perPage="perPage"
          @sort-changed="sorting($event)"
          @paging="currentPageChange($event)"
        />
      </app-content>
    </div>
  </div>
</template>

<script>
import networkManageService from '@/domain/services/generalPanel/networkManagement';
import NetworkManagementHeader from '@/domain/components/generalPanel/networkManagement/NetworkManagementHeader';
import NetworkManagementTable from '@/domain/components/generalPanel/networkManagement/NetworkManagementTable';

export default {
  name: 'NetworkManagementComponent',
  components: {
    NetworkManagementHeader,
    NetworkManagementTable,
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    totalItems: null,
    loading: false,
    items: [],
  }),
  async mounted() {
    await this.getItems(this.currentPage, this.perPage);
  },
  watch: {
    async currentPage() {
      await this.getItems(this.currentPage, this.perPage);
    },
  },
  methods: {
    async getItems(currentPage, perPage) {
      this.loading = true;
      try {
        this.items = [];
        const response = await networkManageService.getList(
          currentPage,
          perPage,
        );
        this.items = response.dados;
        this.totalItems = response.totalRegistros;
        this.perPage = response.tamanhoPagina;
      } finally {
        this.loading = false;
      }
    },
    currentPageChange($event) {
      this.currentPage = $event;
      this.getItems(this.currentPage, this.perPage);
    },
    sorting() {
      this.getItems(this.currentPage, this.perPage);
    },
    goToNewNetwork() {
      const routeData = this.$router.resolve({
        name: 'new-network',
      });
      window.open(routeData.href, '_self');
    },
  },
  computed: {
    hasItems() {
      return (
        this.totalItems > 0 || (this.totalItems && this.totalItems.length > 0)
      );
    },
  },
};
</script>
<style lang="sass" scoped>
.content-wrapper
  margin: 0 3rem 0 3rem
  border: 1px solid #ccc
  border-radius: 0.1rem
.network-management-header
  &__wrapper
    vertical-align: center
    ::v-deep .material-icons-round
      vertical-align: bottom
  &__content
    display: flex
    flex-direction: column
    padding: 25px 40px
    align-items: center
  &__title
    text-transform: uppercase
    width: 100%
    flex-grow: 10
    padding: 0 1rem
::v-deep .app-content__main-content
  padding: 10px 40px
</style>
